const Scrollable = (p: { children: React.ReactNode }) => (
  /**
   * Using "overflow-y-scroll" here prevents the smart panel from
   * shrinking slightly by 4px when there's not enough content to need a scrollbar.
   *
   * Since we're overriding the browser's default scrollbar styling in globals.css,
   * we won't see the standard arrows at both ends of the scrollbar track like we normally would,
   * effectively giving us an invisible scrollbar whose width is still incorporated into the smart panel's width.
   */
  <div className="flex-1 overflow-y-scroll">{p.children}</div>
);

export default Scrollable;
